var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
let MarketCarouselItem = class MarketCarouselItem extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const itemClass = "rj-carousel-item-market" + (this.props.isSelected ? " rj-carousel-item-market--active" : "");
        return (React.createElement("div", { className: itemClass, onClick: this.props.handler, "data-uat": "carousel-item-market" },
            React.createElement("div", { className: "rj-carousel-item-market__details" },
                React.createElement("div", { className: "rj-carousel-item-market__name", "data-uat": "carousel-item-market-name" }, this.props.item.marketName))));
    }
};
MarketCarouselItem = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], MarketCarouselItem);
export { MarketCarouselItem };
//# sourceMappingURL=MarketCarouselItem.js.map